/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Card from "../../Common/Card/Card";
import { Link } from "react-router-dom";
import { GetUpcomingEvents } from "../../services/Web.type.js";
import { usePostQuery } from "../../hooks/reactQueryHelper.js";
import SkeletonCard from "../../Common/loader/Loader.js";
import BlankPage from "../../Common/BlankData/BlankPage.js";

const AboutUs = () => {
  const pathname = window.location.pathname;

  const getUpcomingEventQuery = usePostQuery(
    "getUpcomingEventQuery",
    GetUpcomingEvents,
    {}
  );

  useEffect(() => {
    getUpcomingEventQuery.mutate({ search: "", eventTypeID: [] });
  }, []);

  return (
    <main>
      <section className="section-header-padding">
        <Container className="mt-3">
          <Row>
            <Col lg={12} md={12}>
              <div className="fs-1 bebas-neue-font text-default-color text-center">
                ABOUT US
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section>
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} md={10}>
              <p className="fs-6 plus-jakarta-sans-font text-center mb-0">
                Your ideal companion for cycling,running,and walking events.This
                app is designed to empower your fitness journey. From tracking
                your activities to joining exciting events and challenges,Move
                has your covered.Connect with fellow enthusiasts,monitor your
                progress,and reach new fitness heights.Download the app now and
                get ready to move,one step at a time.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section>
        <Container className="mt-4">
          <Row className="m-2">
            <Col md={12}>
              <div className="fs-2 plus-jakarta-sans-font text-center mb-3">
                Join Event
              </div>
              <Row className="justify-content-center">
                {getUpcomingEventQuery?.data?.result
                  .slice(0, 3)
                  ?.map((item) => (
                    <Card key={item.id} item={item} />
                  ))}
                <SkeletonCard
                  pathname={pathname}
                  getUpcomingEventQuery={getUpcomingEventQuery}
                />
                {getUpcomingEventQuery?.data?.result?.length === 0 && (
                  <BlankPage />
                )}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="position-relative">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-uppercase h3 mt-4 bebas-neue-font text-center">
                <h1>DOWNLOAD THE Move APP NOW!</h1>
              </div>
              <div className="h5 plus-jakarta-sans-font text-center">
                <p>Let’s Get Moving!</p>
              </div>
            </Col>
          </Row>

          <div>
            <div className="d-flex justify-content-center gap-3">
              <Link
                to="https://play.google.com/store/apps?hl=en&gl=US"
                target="_blank"
              >
                <img
                  src="\media\assets\events\google-play.png"
                  alt=""
                  className="img-fluid"
                />
              </Link>
              <Link to="https://www.apple.com/in/app-store/" target="_blank">
                <img
                  src="\media\assets\events\app-store.png"
                  alt=""
                  className="img-fluid"
                />
              </Link>
            </div>
          </div>
          <div className="position-absolute  index-z-left">
            <img
              src="/media/assets/about-us/vactor4.svg"
              alt="Vector 4"
              width={750}
              className="img-fluid"
            />
          </div>
          <div className="position-absolute index-z-right  mt-4">
            <img
              src="/media/assets/about-us/vactor5.svg"
              alt="Vector 5"
              width={350}
              className="img-fluid"
            />
          </div>
        </Container>
      </section>
      <section>
        <div className="container">
          <div>
            <img
              src="/media/assets/about-us/Frame-17.png"
              alt="Group 3"
              className="img-fluid"
            />
          </div>
        </div>
      </section>
    </main>
  );
};
export default AboutUs;
